import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import {
  Card,
  Button,
  Input,
  Row,
  Col,
  Form,
  Collapse,
  Modal,
  Divider,
  Checkbox,
  DatePicker,
  Select,
  Switch,
  Table,
  message,
  Spin,
  Space
} from 'antd'
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  AccountBookFilled
} from '@ant-design/icons'
import ds from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import {
  loadRetailMeasuresModalShow,
  loadRetailMetricsMeasureData
} from '../../appRedux/actions/Reports'
import CustomScrollbars from '../../util/CustomScrollbars'
import { RetailMetricsMeasures } from '../../constants/ReportMeasures'

const ddd__key = JSON.parse(JSON.stringify(RetailMetricsMeasures))

const RetailMeasuresModal = props => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const history = useHistory()

  const getReduxRetailMeasuresModalShow = useSelector(
    ({ Reports }) => Reports.retailMeasuresModal
  )
  const getReduxRetailMetricsMeausureData = useSelector(
    ({ Reports }) => Reports.retailMetricsMeasureData
  )

  const [confirmLoading, setConfirmLoading] = useState(false)
  const [getRetailMetricMeasures, setRetailMetricMeasures] = React.useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getReduxRetailMetricsMeausureData) {
        setRetailMetricMeasures(getReduxRetailMetricsMeausureData)
      }
    }

    return () => {
      mounted = false
    }
  }, [getReduxRetailMetricsMeausureData])

  const handleCancel = () => {
    setConfirmLoading(false)
    dispatch(loadRetailMeasuresModalShow(false))
    // setvisible(false);
    form.resetFields()
  }

  const handleOk = values => {
    form.resetFields()
    setConfirmLoading(true)
    localStorage.setItem(
      'RetailMetricsMeasures',
      JSON.stringify(getRetailMetricMeasures)
    )
    dispatch(loadRetailMetricsMeasureData(getRetailMetricMeasures))
    setConfirmLoading(false)
    dispatch(loadRetailMeasuresModalShow(false))
  }

  const submitEdit = values => {
    setConfirmLoading(true)
    form.resetFields()
  }

  function callback (key) {}
  function onChange (e, key) {
    let data = [...getRetailMetricMeasures]
    if (data && data.length) {
      let dataIndex = data.findIndex(a => a.Key == key)
      data[dataIndex].IsSelected = e.target.checked
      setRetailMetricMeasures(data)
    }
  }

  function onSelectClick (e) {
    if (getRetailMetricMeasures && getRetailMetricMeasures.length > 0) {
      if (isSelectAll) {
        // const defaultMeasures = [...RetailMetricsMeasures]
        const newVal = [...getRetailMetricMeasures]
        newVal.map((a, key) => {
          const defaultValue = ddd__key.filter(
            q => q.DisplayName == a.DisplayName
          )
          if (defaultValue && defaultValue.length > 0) {
            a.IsSelected = defaultValue[0].IsSelected
          }
        })
        setRetailMetricMeasures(newVal)
        setIsSelectAll(false)
      } else {
        setIsSelectAll(true)
        const newVal = [...getRetailMetricMeasures]
        newVal.map(a => (a.IsSelected = true))
        setRetailMetricMeasures(newVal)
      }
    }
  }

  return (
    <Modal
      className='RetailMetrics-modal'
      title={
        <div className='RetailMetrics-title'>
          <strong>
            {' '}
            <IntlMessages id='dashboard.dashboardreporting.showmoreretail' />{' '}
          </strong>
          <p className='mb-0'>
            {' '}
            <IntlMessages id='dashboard.dashboardreporting.choosetheinformation' />{' '}
          </p>
        </div>
      }
      onCancel={handleCancel}
      visible={getReduxRetailMeasuresModalShow}
      confirmLoading={confirmLoading}
      width={800}
      centered={true}
      footer={
        <>
          <Button onClick={handleCancel} size='large' className='dk-btn-cancel'>
            {' '}
            <IntlMessages id='common.resource.cancel' />{' '}
          </Button>
          <Button
            onClick={() => {
              form
                .validateFields()
                .then(values => {
                  handleOk(values)
                })
                .catch(info => {})
            }}
            type='primary'
            size='large'
            className=''
          >
            <IntlMessages id='dashboard.dashboardreporting.updatedashboard' />
          </Button>
        </>
      }
    >
      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={confirmLoading}
        size='large'
      >
        <Form form={form} layout='horizontal' name='RetailMeasureSelectionForm'>
          <Row>
            <Col span={24}>
              <Checkbox
                checked={isSelectAll}
                onChange={e => onSelectClick(e)}
                className='dashboard-checkbox'
              >
                <IntlMessages
                  id={`reporting.dashboard.${
                    !isSelectAll ? 'selectall' : 'setdefault'
                  }`}
                />
                {/* <p className='cb-lable-p'>
                  {' '}
                  <IntlMessages
                    id={`reporting.dashboard.${
                      !isSelectAll ? 'selectalldesc' : 'setdefaultdesc'
                    }`}
                  />{' '}
                </p> */}
              </Checkbox>
            </Col>
          </Row>
          <div className='custom-measure-modal-mg'>
            <Row>
              {getRetailMetricMeasures &&
                getRetailMetricMeasures.map(x => {
                  return (
                    <Col lg={12} md={12} sm={12} xs={24}>
                      <Checkbox
                        checked={x.IsSelected}
                        value={x.Key}
                        onChange={e => onChange(e, x.Key)}
                        disabled={x.IsDisabled}
                        className='dashboard-checkbox'
                      >
                        <IntlMessages id={x.DisplayName} />
                        <p className='cb-lable-p'>
                          {' '}
                          <IntlMessages id={x.Description} />{' '}
                        </p>
                      </Checkbox>
                    </Col>
                  )
                })}
            </Row>
          </div>
        </Form>
      </Spin>
    </Modal>
  )
}
export default RetailMeasuresModal
